// Credits config: pure constants only, safe to import from client components.
// (lib/credits.ts pulls in the db driver — only safe in server code.)

export const CREDITS_PER_VIDEO = 10;

// Signup bonus — one-off grant on a user's first successful sign-in.
export const SIGNUP_BONUS_GRANT = 100;
export const SIGNUP_BONUS_TTL_DAYS = 7;

// Purchased credits — valid for 1 year from purchase.
export const TOPUP_TTL_DAYS = 365;

// Hard upper bound on a submitted video's duration. Anything longer is
// rejected at submit time (see /api/v1/videos POST handler) and never
// reaches the processing pipeline. 10 minutes keeps AI cost predictable.
export const MAX_VIDEO_DURATION_SECONDS = 600;

// Hard upper bound on an uploaded file's size, enforced by the browser before
// sending and by /api/v1/videos/upload while streaming. Matches nginx's
// `client_max_body_size 500M` on prod — raise both together or nginx will
// 413 before the app ever sees the request. Phone footage runs roughly
// 60–130 MB/min at 1080p, so this comfortably covers a typical cooking clip.
export const MAX_UPLOAD_BYTES = 500 * 1024 * 1024;
